import { render, staticRenderFns } from "./BaseUserTable.vue?vue&type=template&id=0c23dbc7"
import script from "./BaseUserTable.vue?vue&type=script&lang=js"
export * from "./BaseUserTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports